import axios from 'axios';
import api from '../../../services/api';
import { REQUEST_TIMEOUT_MS } from '../constants/translationConfig';

/**
 * HTTP client shared by the translation endpoints (languages list and translate-text).
 *
 * A dedicated client is used on purpose: the shared `api` client attaches the login token and
 * turns auth errors into a "session expired" redirect, neither of which applies here (these
 * endpoints need no login, and they must also work on the login page). It reuses the shared
 * client's base URL, which comes from REACT_APP_BASE_URL.
 *
 * `ngrok-skip-browser-warning` matches the shared client: without it, an ngrok-hosted backend
 * answers browser requests with an HTML warning page instead of JSON.
 */
export const translationClient = axios.create({
    baseURL: api.defaults.baseURL,
    timeout: REQUEST_TIMEOUT_MS,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'ngrok-skip-browser-warning': 'true',
    },
});
